import { useState } from 'react';
import { CircleUserRound, LogOut } from 'lucide-react';
import { useLocalstorageState } from 'rooks';
import { useNavigate } from 'react-router-dom';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { useSelf } from '@/data/user';
import { clearToken } from '@/helpers/api';

import UserAccountDialog from './UserAccountDialog';

const UserMenu = () => {
  const user = useSelf();
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useLocalstorageState(`dark-mode`, false);
  const [isAccountDialogOpen, setIsAccountDialogOpen] = useState(false);

  if (user.isLoading || !user.data) {
    return null;
  }

  const handleSignOut = () => {
    clearToken();
    navigate('/login');
  };

  const handleToggleDarkMode = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <Avatar>
            <AvatarImage
              src=""
              alt={`${user.data.firstname} ${user.data.lastname}`}
            />
            <AvatarFallback>{`${user.data.firstname
              .charAt(0)
              .toUpperCase()}${user.data.lastname
              .charAt(0)
              .toUpperCase()}`}</AvatarFallback>
          </Avatar>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuLabel>
            <p>
              {user.data.firstname} {user.data.lastname}
            </p>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => setIsAccountDialogOpen(true)}>
            <CircleUserRound />
            My Account
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleSignOut}>
            <LogOut />
            Sign Out
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <div className="flex gap-2 items-center p-2">
            <Switch
              id="dark-mode"
              checked={isDarkMode}
              onCheckedChange={handleToggleDarkMode}
            />
            <Label htmlFor="dark-mode" className="font-normal">
              Dark Mode
            </Label>
          </div>
        </DropdownMenuContent>
      </DropdownMenu>
      {isAccountDialogOpen && (
        <UserAccountDialog setOpen={setIsAccountDialogOpen} />
      )}
    </>
  );
};

export default UserMenu;
